import { ConfirmationDialogService } from './../../../../confirmation-dialog/confirmation-dialog.service';
import { URLUtils } from 'src/app/urlUtils';
import { HttpService } from 'src/app/services/http.service';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ValidatorFn } from '@angular/forms';
import { LeavepageComponent } from '../leavepage/leavepage.component';
import { GeneralleavepageComponent } from 'src/app/matter/genaralmatter/creategeneralmatter/generalleavepage/generalleavepage.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { catchError, debounceTime, distinctUntilChanged, filter, map, Observable, of, startWith, switchMap, take, tap } from 'rxjs';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatterService } from 'src/app/matter/matter.service';
import { HostListener } from '@angular/core';
import { ConfirmDialogComponent } from 'src/app/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'matter-clients',
    templateUrl: 'matter-clients.component.html',
    styleUrls: ['matter-clients.component.scss'],
    standalone: false
})
export class MatterClientsComponent implements OnInit {

    @Output() selectedClientsEvent: EventEmitter<any> = new EventEmitter();
    @Output() corporateClientsEvent: EventEmitter<any> = new EventEmitter();
    @Input() data: any = {};
    @Input() matterId: any;
    @Input() clients: any = {};
    @Input() corpClients: any = {};
    @Input() groups: any[] = [];
    @Output() temporaryClientsEvent: EventEmitter<any> = new EventEmitter();
    @Output() childButtonEvent: EventEmitter<any> = new EventEmitter();
    @ViewChild('searchInput') searchInput!: ElementRef;
    @Output() clientsSaved = new EventEmitter<boolean>();
    // @ViewChild('auto') auto!: MatAutocomplete;
    @ViewChild(MatAutocompleteTrigger) auto!: MatAutocompleteTrigger;
    isEdit: boolean = false; 

    displayMouseOver: boolean = false;
    clientsList: any = [];
    selectedClients: any = [];
    searchText: any = '';
    tooltipgroupslist: any;
    tempList: any = [];
    tempClient: any = FormGroup;
    individualClient: any = FormGroup;
    entityClient: any = FormGroup;
    corporateClient: any = FormGroup;
    filteredData: any;
    inputsubmit: any;
    selectedType: string = 'individual';
    selectedClient: string = 'addclient';
    submitted = false;
    entitysubmitted: boolean = false;
    tempClients: any = [];
    ClientType: string = 'individual';
    CorpType: string = 'corporate';
    csvContent: any = [];

    corporateList: any = [];
    corporateData: boolean = false;
    //corpClients: any = [];
    selectedOption = "";
    selectedprod = 'clients';
    selectedprodCorp = 'corporate';
    product = environment.product;
    showTempForm: boolean = false;

    relationshipSubscribe: any;
    reldata: any[] = [];
    clidata: any;
    corpData: any[] = [];
    isSelectAllVisible = true;
    successModel: boolean = false;
    formType: any;
    keyModel: boolean = false;
    isSaveEnable: boolean = false;
    pathName: string = "legalmatter";
    groupName:any;
    showAllItems = false;
    originalClientsList:any[]=[];
    selectedEntity = new FormControl("");
    selectedEntityObject = {entityId: ""};
    filteredEntities: any;
    emptySearchError: boolean = false;
    currentSearchList: any[] = [];
    @Input() clientsWereSaved:any;
    @Input() clientsData:any;
    reqId:any;
    selId:any;
    removedClientIds: number[] = [];
    editeMatterInfo:any;
    matterid:any;

    originalClientIds: number[] = [];
    hasNewClientsAdded = false;

    
    @HostListener('window:beforeunload', ['$event'])
    handleBeforeUnload(event: BeforeUnloadEvent) {
        if (this.hasNewClientsAdded) {
            event.preventDefault();
            event.returnValue = ''; // to show warning
        }
    }

    constructor(private httpservice: HttpService, private fb: FormBuilder,
        private confirmationDialogService: ConfirmationDialogService,
        private httpService: HttpService,private dialog: MatDialog, private router: Router,
        public toastr: ToastrService, private matterService: MatterService) { }

    ngOnInit() {
        // console.log('data', this.data)
        // console.log('matterId', this.matterId)
        // console.log('reldata', this.reldata)
        // console.log('selectedprod', this.selectedprod)
        // console.log('selectedprodCorp', this.selectedprodCorp)
        // console.log('selectedClients', this.selectedClients)
        // console.log('clientsList', this.clientsList)
        // console.log('clientsData', this.clientsData)
        // console.log('clients', this.clients)
        // console.log('corpClients', this.corpClients)
        // console.log('corporateData',this.corporateData)
        // console.log('clientsWereSaved',this.clientsWereSaved)
        // console.log('remcIds', this.removedClientIds)


        if (this.clientsWereSaved === false || this.clientsData === undefined) {
            this.clients = [];
        }

        if(this.clientsData.length !== 0){
        this.selectedClients = this.clients;
        // console.log('ss selectedClients',this.selectedClients)
        }

        if (this.clients[0]?.type === 'corporate') {
            this.selectedprod = 'corporate'; // assign corp
            this.corporateData = true;
        } else {
            this.selectedprod = 'clients'; // default
        }
        

        this.httpservice.sendGetRequest(URLUtils.getCountry).subscribe((res: any) => {
            res.data.countries.forEach((item: any) => {
                // console.log("item is "+JSON.stringify(item[0]));
                this.csvContent.push(item[0]);
            })
            // Set India as default and disable
            this.tempClient.get('country')?.setValue('India');
            this.tempClient.get('country')?.disable();

            this.entityClient.get('country')?.setValue('India');
            this.entityClient.get('country')?.disable();
            this.csvContent.shift();

        });
        let tmClient: any = localStorage.getItem('tempClients');
        tmClient = JSON.parse(tmClient);
        if (tmClient != "null")
            this.tempClients = tmClient?.length > 0 ? tmClient : [];
        this.tempClient = this.fb.group({
            name: ['', Validators.required],
            lastName: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            confirmemail: ['', [Validators.required, Validators.email]],
            //country: ['India', Validators.required],
            country: [{ value: 'India', disabled: true }],
            phonenumber: [''],
            type: ['individual', Validators.required]
        }, { validator: this.emailMatchValidator() });

        //this.getClients();
        this.entityClient = this.fb.group({
            fullname: ['', Validators.required],
            contact_person: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            confirmemail: ['', [Validators.required, Validators.email]],
            //country: ['', Validators.required],
            country: [{ value: 'India', disabled: true }],
            phonenumber: [''],
        }, { validator: this.emailMatchValidator() });

        //this.getClientsData(); //doc. list clients
        if (this.product == 'corporate') {
            this.getClients();
        }
        else {
            // this.getClientsData();
        }
        if (window.location.pathname.indexOf("edit") > -1) {
     
   

       this.matterService.editLegalMatterObservable
            .pipe(take(1))
            .subscribe((result: any) => {
            if (result) {
                this.matterId = result.id;
                this.editeMatterInfo = result;
                // console.log('editeMatterInfo',this.editeMatterInfo)

                this.isEdit = true;
                const clients = result.clients ?? [];
                const corporate = result.corporate ?? [];

                if (clients.length === 0 && corporate.length === 0) {
                    this.selectedClients = [];
                    return;
                }
                this.selectedClients = clients.length ? clients : corporate;
                //console.log('sclients',this.selectedClients)

                // Store original client IDs
                this.originalClientIds = (result.clients || []).map((c: any) => c.id);
            }
            });

         this.matterService.editGeneralMatterObservable
            .pipe(take(1))
            .subscribe((result: any) => {
            if (result) {
                this.matterId = result.id;
                this.editeMatterInfo = result;
                //console.log('editeMatterInfo', this.editeMatterInfo)
                this.isEdit = true;
                const clients = result.clients ?? [];
                const corporate = result.corporate ?? [];

                if (clients.length === 0 && corporate.length === 0) {
                    this.selectedClients = [];
                    return;
                }
                this.selectedClients = clients.length ? clients : corporate;
                // console.log('sclients',this.selectedClients)
                //this.selectedClients = result.clients || [];
            }
            }); 
    }
        // console.log('temp clients', this.tempList)
        // console.log('showTempForm', this.showTempForm)
        // console.log('corporateData', this.corporateData)
        // console.log('clientsList', this.clientsList)

        // get search clients
        // this.filteredEntities = this.selectedEntity.valueChanges.pipe(
        //     debounceTime(300),
        //     distinctUntilChanged(),
        //     tap((value: any) => {
        //         if (!value || value.trim() === '') {
        //             this.showTempForm = false;     // <— hide temp form
        //             this.currentSearchList = [];    // optional
        //         }
        //     }),
        //     filter(value => value && value.trim().length > 0),
        //     switchMap(value => this.searchClients(value))
        // );

        this.filteredEntities = this.selectedEntity.valueChanges.pipe(
            debounceTime(300),
            map(value => value?.trim()),
            distinctUntilChanged(),
            switchMap(value => {
                // Empty val
                if (!value) {
                    this.showTempForm = false;
                    this.currentSearchList = [];
                    return of([]); // important
                }
                return this.searchClients(value); // ONLY call API when user types
            })
        );
    }


    searchClients(searchText: any): Observable<any[]> {
        const payload = { search: searchText || '' };

        return this.httpservice.sendPostRequest(URLUtils.searchClient, payload).pipe(
            map((res: any) => {
                let clientList = res?.clients || [];

                const filteredList = clientList.filter((item: any) =>
                    !this.selectedClients.some((s: any) => s.id === item.client_id)
                );
                this.currentSearchList = filteredList;

                // Show temp form ONLY if list empty AND input is NOT empty
                //this.showTempForm = filteredList.length === 0 && searchText.trim().length > 0;
                this.showTempForm =
                    filteredList.length === 0 &&
                    searchText.trim().length > 0 &&
                    !this.hasCorporateSelected;

                return filteredList;
            }),
            catchError((err) => {
                console.error(err);

                // If input is empty → don't show temp form
                if (!searchText || searchText.trim() === '') {
                    this.showTempForm = false;
                }

                // Must return Observable ALWAYS
                return of([]);
            })
        );
    }

    sendReq(req?:any) {
        // console.log('ss',req)
        // console.log('ss reqid', this.reqId)
        // console.log('ss selectedClients', this.selectedClients);

        let ebody = {
            "entityId": req.id,
            "description": "Description",
        }
        let cbody = {
            "consumerId": req.id,
            "description": "Description",
        }

        if (req.type === "consumer") {
            this.httpservice.sendPostRequest(URLUtils.relationshipConsumerRequest, cbody).subscribe(
                (resp: any) => {
                //    if(resp.error === false)
                //      //this.toastr.success("Client Request Sent Successfully");
                //        console.log(resp)
                //     else
                //      this.toastr.error(resp.msg);
                },
                (error: HttpErrorResponse) => {
                    if (error.status === 401 || error.status === 403) {
                        const errorMessage = error.error.msg || 'Unauthorized';
                        this.toastr.error(errorMessage);
                        //console.log(error);
                    }
                })
        }
        else  if (req.type === "entity") {
            this.httpservice.sendPostRequest(URLUtils.relationshipEntityRequest, ebody).subscribe(
                (resp: any) => {
                    // if(resp.error === false)
                    //  //this.toastr.success("Client Request Sent Successfully");
                    //   console.log(resp)
                    // else
                    //  this.toastr.error(resp.msg);
                },
                (error: HttpErrorResponse) => {
                    if (error.status === 401 || error.status === 403) {
                        const errorMessage = error.error.msg || 'Unauthorized';
                        this.toastr.error(errorMessage);
                        //console.log(error);
                    }
                });
        }
        else  if (req.type === "corporate") {
            this.httpservice.sendPostRequest(URLUtils.relationshipCorporateRequest, ebody).subscribe(
                (resp: any) => {
                    // if(resp.error === false)
                    //  //this.toastr.success("Client Request Sent Successfully");
                    //    console.log(resp)
                    // else
                    //  this.toastr.error(resp.msg);
                },
                (error: HttpErrorResponse) => {
                    if (error.status === 401 || error.status === 403) {
                        const errorMessage = error.error.msg || 'Unauthorized';
                        this.toastr.error(errorMessage);
                        //console.log(error);
                    }
                });
        }
        else{}
    }


    onOptSel(event: any) {
        const selectedName = event.option.value;
        const selectedObj = this.currentSearchList.find(
            (c: any) => c.client_name === selectedName
        );

        if (!selectedObj) return;

        const isCorporate = selectedObj.type === 'corporate';
        const hasCorporate = this.hasCorporateSelected;
        const hasNonCorporate = this.hasNonCorporateSelected;
        //console.log('this.showTempForm',this.showTempForm)

        // Corporate already selected → block another corporate
        if (isCorporate && hasCorporate) {
            // this.confirmationDialogService.confirm(
            //     'Alert',
            //     'Multi Corporate Client Selection Not Allowed',
            //     false,
            //     'OK',
            //     'Cancel',
            //     true
            // );
            const dialogRef = this.dialog.open(ConfirmDialogComponent, {
                width: '400px',
                data: { title: 'Alert', message: `Multi Corporate Client Selection Not Allowed`,hideButtons: true }
            });
            dialogRef.afterClosed().subscribe((result: any) => {
                if (result) {
                }
            });

            this.selectedEntity.setValue(null);
            return;
        }

        // Corporate selected → block entity / consumer
        if (!isCorporate && hasCorporate || (this.showTempForm === false && hasCorporate)) {
            // this.confirmationDialogService.confirm(
            //     'Alert',
            //     'This action is not allowed: Corporate clients cannot be grouped with other clients.',
            //     false,
            //     'OK',
            //     'Cancel',
            //     true
            // );
            const dialogRef = this.dialog.open(ConfirmDialogComponent, {
                width: '400px',
                data: {
                    title: 'Alert', message: `This action is not allowed: Corporate clients cannot be grouped with other clients.`, hideButtons: true
                }
            });
            dialogRef.afterClosed().subscribe((result: any) => {
                if (result) {
                }
            });
            
            this.selectedEntity.setValue(null);
            return;
        }

        // Entity / Consumer selected → block corporate
        if (isCorporate && hasNonCorporate) {
            // this.confirmationDialogService.confirm(
            //     'Alert',
            //     'Corporate client can not be added when other clients are already selected',
            //     false,
            //     'OK',
            //     'Cancel',
            //     true
            // );
            const dialogRef = this.dialog.open(ConfirmDialogComponent, {
                width: '400px',
                data: { title: 'Alert', message: `Corporate client can not be added when other clients are already selected.`,hideButtons: true }
            });
            dialogRef.afterClosed().subscribe((result: any) => {
                if (result) {
                }
            });
            this.selectedEntity.setValue(null);
            return;
        }

        // Duplicate check
        if (this.selectedClients.some((c:any) => c.id === selectedObj.client_id)) {
            this.selectedEntity.setValue(null);
            return;
        }

        // Add client
        const addedClient = {
            id: selectedObj.client_id,
            name: selectedObj.client_name,
            type: selectedObj.type,
            send_request: selectedObj.send_request
        };

        this.selectedClients.push(addedClient);

        // Check if this client was NOT in original list
        if (!this.originalClientIds.includes(addedClient.id)) {
            this.hasNewClientsAdded = true;
        }
        this.toastr.success("Client Request Sent Successfully");
        this.reqId = addedClient.id;

        if (addedClient.send_request) {
            this.sendReq(addedClient);
        }

        this.httpService.setClients(this.selectedClients);
        this.selectedEntity.setValue(null);
    }

    get hasCorporateSelected(): boolean {
        return this.selectedClients.some((c: any) => c.type === 'corporate');
    }

    get hasNonCorporateSelected(): boolean {
        return this.selectedClients.some(
            (c: any) => c.type !== 'corporate'
        );
    }

    stopOpen() {
        if (!this.selectedEntity.value || this.selectedEntity.value.trim() === '') {
            //this.auto.closePanel();
            this.selectedEntity.setValue('');
        }
    }

    restrictSpaces(event: any) {
        let inputValue: string = event.target.value;
        if (inputValue.length > 0 && inputValue.charAt(0) === ' ') {
            inputValue = inputValue.substring(1);
            event.target.value = inputValue;
            return;
        }
    }

    searchEntity() { }

    //searchEntity() {
        // this.reqError.show = false;
        // this.closeMode = false;
        // if(this.selectedEntityObject.entityId.length > 0){
        //   this.emptySearchError = false;
        //   this.httpservice.sendGetRequest(URLUtils.relationshipEntityDetails(this.selectedEntityObject)).subscribe((res: any) => {
        //     if(!res.error){
        //       ['entityName', 'email', 'contactPhone', 'contactPerson', 'country'].forEach((item: any, index: number) => {
        //         let ctl = this.createRelationform.controls[item]
        //         ctl.setValue(res.data[item])
        //         ctl.disable()
        //       })
        //       this.createRelationform.controls['confirmEmail'].setValue(res.data['email'])
        //       this.formMode = 'request'
        //       this.showForm = true
        //       this.selname = res.data['entityName']
        //       this.msg = `Entity ${res.data['entityName']} Found!`
        //       this.loadGroups()
        //       this.selectedEntity.setValue("")
        //       this.selectedGroups = []
        //       this.seid = this.selectedEntityObject['entityId']
        //       this.selectedEntityObject = {entityId: ""};
        //     }
        //   })
        // } else {
        //     if(this.selectedEntity.value === ' '){
        //       this.emptySearchError = true;
        //       this.msg = ` `
        //       return;
        //     }
        //     // this.emptySearchError = false;
        //     ['entityName','email','contactPhone', 'contactPerson', 'country', 'confirmEmail'].forEach((item: any, index: number) => {
        //           this.createRelationform.controls[item].setValue("")
        //           this.createRelationform.controls[item].enable()
        //     })
        //     if(this.selectedEntity.value !== ' '){
        //     this.emptySearchError = false;
        //     this.formMode = 'invite'
        //     this.selname = this.createRelationform.value['entityName']
        //     this.showForm = true
        //     this.msg = `${this.selectedEntity.value} - not found. Please fill in the details below to send the relationship invite.`
        //     }
        //     this.loadGroups()
        //     this.selectedGroups = []
        //     this.selectedEntity.setValue("")
        // }
    //}

    getTempData() {
        this.relationshipSubscribe = this.httpservice.getFeaturesdata(URLUtils.relationshipTemporary).subscribe((res: any) => {
        })
    }

    getClientsData() {
        this.relationshipSubscribe = this.httpservice.getFeaturesdata(URLUtils.getAllRelationship).subscribe((res: any) => {
            this.clientsList = res?.data?.relationships;
            this.originalClientsList = this.clientsList;

            this.httpservice.getFeaturesdata(URLUtils.getCalenderExternal).subscribe((res: any) => {
                this.corporateList = res?.relationships.map((obj: any) => ({ "id": obj.id, "type": "corporate", "name": obj.name }));

                // Filter selected clients from clientsList and corporateList
                const selectedClientIds = this.selectedClients.map((client: { id: any; }) => client.id);
                this.clientsList = this.clientsList.filter((client: { id: any; }) => !selectedClientIds.includes(client.id));
                this.corporateList = this.corporateList.filter((client: { id: any; }) => !selectedClientIds.includes(client.id));

                // Combine clientsList and corporateList into clients
                this.clients = [...this.clientsList, ...this.corporateList];
            });

            this.tempList.length = this.clientsList.length;
            this.corporateList.length = this.corporateList.length;

            if (this.clients && this.clients.length > 0) {
                this.selectedClients = [...this.clients];

                // Update clientsList to exclude selected clients
                this.clientsList = this.clientsList.filter((el: any) => {
                    return !this.selectedClients.find((element: any) => element.id === el.id);
                });
            }

            if (this.corpClients && this.corpClients.length > 0) {
                this.selectedClients = [...this.corpClients];

                // Update corporateList to exclude selected clients
                this.corporateList = this.corporateList.filter((el: any) => {
                    return !this.selectedClients.find((element: any) => element.id === el.id);
                });
            }
            // Final update of combined clients list
            this.clients = [...this.clientsList, ...this.corporateList];
            this.originalClientsList = [...this.clientsList];

            if (this.selectedClients.length == 0) {
                let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
                if (checkbox != null)
                    checkbox.checked = false;
            }
            if (this.clients.length === 0) {
                let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
                if (checkbox != null)
                    checkbox.checked = true;
            }
        });
    }

    // Check emails of two fields match
    emailMatchValidator(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            const formGroup = control as FormGroup;
            const email = formGroup.get('email')?.value;
            const confirmEmail = formGroup.get('confirmemail')?.value;
            return email && confirmEmail && email !== confirmEmail ? { emailMismatch: true } : null;
        };
    }

    get f() {
        return this.tempClient.controls;
    }
    get f1() {
        return this.entityClient.controls;
    }

    getClients() {
        let grps = this.groups.map((obj: any) => obj.id);
        let newGroups = [...this.groups];

        this.groupName = this.groups.map((obj: any) => obj.name);
        // console.log('grp',this.groupName)

        if (newGroups && newGroups.length > 2) {
            let tooltipGroupsArray = newGroups.splice(2, this.groups.length);
            // if (tooltipGroupsArray && tooltipGroupsArray.length > 0) {
            //     tooltipGroupsArray.forEach((element: any) => {
            //         this.tooltipgroupslist = this.tooltipgroupslist + ',' + element.name;
            //     });
            // this.tooltipgroupslist = this.tooltipgroupslist.slice(1);
            this.tooltipgroupslist = tooltipGroupsArray.map((item: any, i: number) => item.name);
        }
        var payload
        if (this.product == "corporate") {
            payload = { 'group_acls': grps, 'attachment_type': 'corporate', 'product': this.product }

        } else {
            payload = { 'group_acls': grps, 'attachment_type': 'clients' }
        }
        this.httpservice.sendPutRequest(URLUtils.getFilterTypeAttachements, payload).subscribe(
            (res: any) => {
                this.selectedClients = [];
                this.clientsList = res['corporate'];
                // console.log('clientsList', this.clientsList);
                // console.log('selectedClients', this.selectedClients);
                if (this.clients && this.clients.length > 0) {
                    this.clients.forEach((client: any) => {
                        const matchedClient = this.clientsList.find((el: any) => el.id === client.id);
                        if (matchedClient) {
                            this.selectedClients.push(matchedClient);
                        }
                    });
                    // Filter the clientsList to remove already selected clients
                    this.clientsList = this.clientsList.filter((el: any) => {
                        return !this.selectedClients.find((selectedClient: any) => selectedClient.id === el.id);
                    });                    
                    // console.log('Filtered clientsList', this.clientsList);
                    // console.log('Updated selectedClients', this.selectedClients);
                }
        
                // Handle the 'selectAll' checkbox
                if (this.selectedClients.length == 0) {
                    let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
                    if (checkbox != null) {
                        checkbox.checked = false;
                    }
                }
            }
        );
        // this.httpservice.sendPutRequest(URLUtils.getFilterTypeAttachements, payload).subscribe(
        //     (res: any) => {
        //         if (!res['error'] && res['clients']?.length > 0) {
        //             this.clientsList = res['clients'];
        //         } else if (!res['error'] && res['corporate']?.length > 0) {
        //             this.clientsList = res['corporate'];
        //         }
        //         this.tempList.length = this.clientsList.length;
        //         if (this.clients && this.clients.length > 0) {
        //             this.selectedClients = [...this.clients];
        //             let res = this.clientsList.filter((el: any) => {
        //                 return !this.selectedClients.find((element: any) => {
        //                     return element.id === el.id;
        //                 });
        //             });
        //             this.clientsList = res;

        //         }
        //         if (this.selectedClients.length == 0) {
        //             let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
        //             if (checkbox != null)
        //                 checkbox.checked = false;
        //         }
        //     }
        // )
        // this.httpservice.sendPutRequest(URLUtils.getFilterTypeAttachements, payload).subscribe(
        //     (res: any) => {
        //         if (!res['error'] && res['corporate']?.length > 0)
        //             this.corporateList = res['corporate'];
        //         this.tempList.length = this.corporateList.length;
        //         if (this.clients && this.clients.length > 0) {
        //             this.selectedClients = [...this.clients];
        //             let res = this.corporateList.filter((el: any) => {
        //                 return !this.selectedClients.find((element: any) => {
        //                     return element.id === el.id;
        //                 });
        //             });
        //             this.corporateList = res;
        //         }

        //         if (this.selectedClients.length == 0) {
        //             let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
        //             if (checkbox != null)
        //                 checkbox.checked = false;
        //         }
        //     }
        // )
    }

    onFilterValueChange() {
        this.tempList = this.clientsList.filter((data: any) => data?.name?.toLowerCase().includes(this.searchText?.toLowerCase()));
        this.clientsList = this.tempList.filter((data: any) => data?.name?.toLowerCase().includes(this.searchText?.toLowerCase()));
        this.tempList = this.corporateList.filter((data: any) => data?.name?.toLowerCase().includes(this.searchText?.toLowerCase()));
        //console.log('Onnnthis.filtered',this.clientsList )
    }

    selectAll(event: any) {
        this.isSaveEnable = true;
        if (event?.target?.checked) {
            this.tempList = !this.tempList;
            // if (this.clientsList?.length > 0) {
            //     if (this.filteredData?.length > 0) {
            //         //this.selectedClients = this.selectedClients.concat(this.filteredData);
            //         this.selectedClients = this.selectedClients.concat(this.clientsList);
            //         this.clientsList = this.clientsList.filter((el: any) => {
            //             return !this.selectedClients.find((element: any) => {
            //                 return element.id === el.id;
            //             });
            //         });
            //     } else {
            //         this.selectedClients = this.selectedClients.concat(this.clientsList);
            //         this.clientsList = [];
            //     }
            // }

            // Filter clientsList based on searchText
            const filteredClients = this.clientsList.filter((client: any) =>
                client.name.toLowerCase().includes(this.searchText.toLowerCase())
            );
            if (filteredClients?.length > 0) {
                this.selectedClients = this.selectedClients.concat(filteredClients);
                this.clientsList = this.clientsList.filter((el: any) => {
                    return !this.selectedClients.find((element: any) => {
                        return element.id === el.id;
                    });
                });
            }
        } else {
            this.clientsList = this.selectedClients.concat(this.clientsList);
            this.selectedClients = [];
        }
        this.searchText = '';
        this.httpService.setClients(this.selectedClients); //observing the selectedClients
    }

    selectCorp(event: any) {
        //console.log(this.corporateList)
        if (event?.target?.checked) {
            if (this.corporateList?.length > 0) {
                //console.log('CC',this.corporateList)
                if (this.filteredData?.length > 0) {
                    this.selectedClients = this.selectedClients.concat(this.filteredData);
                    this.corporateList = this.corporateList.filter((el: any) => {
                        return !this.selectedClients.find((element: any) => {
                            return element.id === el.id;
                        });
                    });
                } else {
                    this.selectedClients = this.selectedClients.concat(this.corporateList);
                    this.corporateList = [];
                }
            }
        } else {
            this.corporateList = this.selectedClients.concat(this.corporateList);
            this.selectedClients = [];
        }
    }

    // selectClient(group: any, value?: any) {
    //     this.selectedClients.push(group);
    //     this.tempList = !this.tempList;
    //     let index = this.clientsList.findIndex((d: any) => d.id === group.id); //find index in your array
    //     this.clientsList.splice(index, 1);
    //     if (this.clientsList.length == 0) {
    //         let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
    //         if (checkbox != null)
    //             checkbox.checked = true;
    //     }
    // }

    selectClient(client: any, isChecked: boolean) {
        this.isSaveEnable = true;
        if (isChecked) {
            this.selectedClients.push(client);
            let index = this.clientsList.findIndex((d: any) => d.id === client.id); // Find index in your array
            if (index !== -1) {
                this.clientsList.splice(index, 1);
            }
        } else {
            // Handle unselecting a single client
            let index = this.selectedClients.findIndex((d: any) => d.id === client.id);
            if (index !== -1) {
                this.selectedClients.splice(index, 1);
                this.clientsList.push(client);
            }
        }

        if (this.clientsList.length == 0) {
            let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
            if (checkbox != null) {
                checkbox.checked = true;
            }
        }
        this.httpService.setClients(this.selectedClients); //observing the selectedClients
    }

    selectCorporate(group: any, value?: any) {
        this.isSaveEnable = true;
        this.selectedClients.push(group);
        let index = this.corporateList.findIndex((d: any) => d.id === group.id); //find index in your array
        this.corporateList.splice(index, 1);
        if (this.corporateList.length == 0) {
            let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
            if (checkbox != null)
                checkbox.checked = true;
        }
        //console.log("Corp selected clients "+JSON.stringify(this.selectedClients));
    }

    removeClient(group: any) {
        this.selId = group;
        // let index = this.selectedClients.findIndex((d: any) => d.id === group.id); //find index in your array
        // this.selectedClients.splice(index, 1);
        // this.clientsList.push(group);
        this.selectedOption = ""; // Reset the dropdown selection
        this.isSaveEnable = true;

        // mark client for removal
        if (!this.removedClientIds.includes(group.id)) {
            this.removedClientIds.push(group.id);
        }
        // console.log('Marked for removal:', this.removedClientIds);

        // let index = this.selectedClients.findIndex((d: any) => d.id === group.id);
        // if (index > -1) {
        //     this.selectedClients.splice(index, 1);
        // }

        // If the type is corp/notcorporate, push back to its respective List
        if (group.type !== 'corporate') {
            //this.clientsList.push(group);
            this.selectedClients = this.selectedClients.filter((c: any) => c.id !== group.id);
            this.selectedEntity.setValue(null); 
        }
        if (group.type === 'corporate') {
            let index = this.selectedClients.findIndex((d: any) => d.id === group.id);
            if (index > -1) {
                this.selectedClients.splice(index, 1);
            }

            this.corporateList.push(group);
            this.httpservice.getFeaturesdata(URLUtils.getCalenderExternal).subscribe((res: any) => {
                this.corporateList = res?.relationships.map((obj: any) => ({ "id": obj.id, "type": "corporate", "name": obj.name }));
            });
        }
        // if (this.selectedClients.length == 0 || this.clientsList.length == 1) {
        //     let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
        //     if (checkbox != null)
        //         checkbox.checked = false;
        // }
         
        // Recalculate: are there still any new clients?
        const currentIds = this.selectedClients.map((c: any) => c.id);
        this.hasNewClientsAdded = currentIds.some((id: any) => !this.originalClientIds.includes(id));
    }

    saveClients() {
        const tempVal = (this.tempClient.value.name?.length > 1 || 
            this.tempClient.value.lastName?.length > 1 || 
            this.tempClient.value.email?.length > 1 || 
            this.tempClient.value.country?.length > 1);

        const entityVal = (this.entityClient.value.fullname?.length > 1 || 
              this.entityClient.value.contact_person?.length > 1 || 
              this.entityClient.value.email?.length > 1 || 
              this.entityClient.value.country?.length > 1);

        if (tempVal || entityVal) {
            this.toastr.error('Please save your changes to proceed');
            return;
        }
        else{  
            // Apply removals ONLY when saving
            this.removedClientIds.forEach((id) => {
                let index = this.selectedClients.findIndex(
                    (d: any) => d.id === id
                );
                if (index > -1) {
                    this.selectedClients.splice(index, 1);
                }
            });
            this.removedClientIds = []; // Clear queue after save

            // console.log('save clients:', clients);
            // console.log('save selectedClients:', this.selectedClients);
            // console.log('save clisaved:', this.clientsWereSaved);
            // console.log('save data', this.data)
            // console.log('save reldata', this.reldata)
            // console.log('save selectedprod', this.selectedprod)
            // console.log('save clientsList', this.clientsList)
            // console.log('save clientsData', this.clientsData)
            // console.log('save clients', this.clients)
            // console.log('save clientsWereSaved', this.clientsWereSaved)
            // console.log('removedClientIds', this.removedClientIds)
            // console.log('seleIdd', this.selId)
            let clients = this.selectedClients.filter((element: any) => element)
                .map((c: any) => ({
                    id: c.id,
                    type: c.type
                }));
            let corporateClient = this.selectedClients.find(
                (c: any) => c.type === 'corporate'
            );

            const isCorporate =
                corporateClient ||
                this.selId?.type === 'corporate';

            // let payload = isCorporate
            //     ? { corporate: corporateClient?.id || '' }
            //     : { clients};
            let payload = isCorporate
                ? {
                    corporate: corporateClient?.id || '',
                    clients: []
                }
                : {
                    clients
                };

            // console.log('payload:', payload);
            // console.log('matterId:', this.matterId);
            const url = this.data.type === 'general'
                ? URLUtils.patchGeneralMatter(this.matterId)
                : URLUtils.patchLegalMatter(this.matterId);

            this.httpService.sendPatchRequest(url, payload).subscribe({
            next: (res: any) => {
                // if (!res?.error) {
                // this.toastr.success('Client(S) added successfully!');
                // } else {
                // this.toastr.error(res?.msg || 'Something went wrong');
                // }
            },
            error: (error: HttpErrorResponse) => {
                if (error.status === 401 || error.status === 403) {
                this.toastr.error(error?.error?.msg || 'Unauthorized');
                } else {
                this.toastr.error('Failed to update matter');
                }
            }
            });

            this.pathName = window.location.pathname.includes("legalmatter") ? "legalmatter" : "generalmatter";
            //console.log('pathname', this.pathName)
            let cancel = localStorage.getItem('oncancel');
            if (cancel) {
                localStorage.removeItem('oncancel');
                this.router.navigate([`/matter/${this.pathName}/view`]);
                return;
            }

            let selectedIds = this.tempClients.map((s: any) => s.id);
            this.temporaryClientsEvent.emit(selectedIds)

            let client = this.selectedClients.filter((element: any) => element);
            this.selectedClientsEvent.emit(client);

            // Mark that clients were saved successfully
            this.clientsSaved.emit(true);
        }
        sessionStorage.clear();
        //this.clients = this.httpService.getClients();
        //console.log('save clients',this.clients)

        // let selectedIds = this.tempClients.map((s: any) => s.id);
        // this.temporaryClientsEvent.emit(selectedIds)
        // let clients = this.selectedClients.filter((element: any) => element);
        // this.selectedClientsEvent.emit(clients)
        //console.log('clientsclients',clients)
        
        // let clients = this.selectedClients.filter((element: any) => element.type !== "corporate");
        // this.selectedClientsEvent.emit(clients);
        // let corp = this.selectedClients.find((element: any) => element.type === "corporate");
        // this.corporateClientsEvent.emit(corp.id);
    }

    onClickCorp() {
        this.isSaveEnable = true;
        let flag = false;
        for (let i = 0; i < this.selectedClients.length; i++) {
            //console.log("Corp selected clients",this.selectedClients)
            if (this.selectedClients[i].type === "corporate") {
                this.selectedClients[i] = this.selectedOption;
                flag = true;
                break;
            }
        }
        if (!flag) {
            this.selectedClients.push(this.selectedOption);
        }
    }

    OnSaveLater() {
        // this.clientsList = this.clientsList.concat(this.selectedClients);
        // this.selectedClients = [];
        localStorage.setItem('oncancel', "oncancel");
        this.pathName = window.location.pathname.includes("legalmatter") ? "legalmatter" : "generalmatter";
        if (this.selectedClients.length === 0 || this.selectedClients.length > 0) {
            this.saveClients();
            // if(this.pathName === "legalmatter"){
            // this.dialog.open(LeavepageComponent, {
            //     width: '350px',  // Set the width here
            //     height: '180px',
            //     hasBackdrop: true,
            //     panelClass: 'hello',
            //     disableClose: true
            // });
            // return;
            // }
            // else if(this.pathName === "generalmatter"){
            //     this.dialog.open(GeneralleavepageComponent, {
            //         width: '350px',  // Set the width here
            //         height: '180px',
            //         hasBackdrop: true,
            //         panelClass: 'hello',
            //         disableClose: true
            //     });
            //     return; 
            // }
            // else{}
        }
        const checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
        if (checkbox) {
            checkbox.checked = false;
        }
    }
        
    OnCancel() {
        // this.clientsList = this.clientsList.concat(this.selectedClients);
        // this.selectedClients = [];
        localStorage.setItem('oncancel', "oncancel");
        this.pathName = window.location.pathname.includes("legalmatter") ? "legalmatter" : "generalmatter";
        if (this.selectedClients.length > 0) {
            //this.saveClients();
            if(this.pathName === "legalmatter"){
            this.dialog.open(LeavepageComponent, {
                width: '350px',  // Set the width here
                height: '180px',
                hasBackdrop: true,
                panelClass: 'hello',
                disableClose: true
            });
            return;
            }
            else if(this.pathName === "generalmatter"){
                this.dialog.open(GeneralleavepageComponent, {
                    width: '350px',  // Set the width here
                    height: '180px',
                    hasBackdrop: true,
                    panelClass: 'hello',
                    disableClose: true
                });
                return; 
            }
            else{
                this.router.navigate([`/matter/${this.pathName}/view`]);
            }
        }
        else {
            this.router.navigate([`/matter/${this.pathName}/view`]);
        }
        const checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
        if (checkbox) {
            checkbox.checked = false;
        }
    }

    OnFormCancel() {
        const tempVal = this.tempClient.value.name.length > 1 || this.tempClient.value.lastName.length > 1 || this.tempClient.value.email.length > 1 || this.tempClient.value.country.length > 1;
        const entityVal = this.entityClient.value.fullname.length > 1 || this.entityClient.value.contact_person.length > 1 || this.entityClient.value.email.length > 1 || this.entityClient.value.country.length > 1;

        if (tempVal) {
            this.keyModel = true;
             this.showAlert();
            return;
        }
        else if (entityVal) {
            this.keyModel = true;
            this.showAlert();
            return;
        }
        else{        
        this.tempList = false;
        this.isSelectAllVisible = true;
        this.showTempForm = false;
        this.entityClient.reset();
        this.tempClient.reset();
        //this.onFilterValueChange();
        this.submitted = false;
        this.entitysubmitted = false;
        //this.clientsList = this.clientsList.concat(this.selectedClients);
        this.clientsList = this.originalClientsList.filter((client: any) =>
                !this.selectedClients.includes(client)
        ); // get back the client list
        this.showTempForm = false;
        //this.selectedClients;
        //this.getClients();
        //this.getClientsData();
        this.childButtonEvent.emit(this.clients);
        this.searchText = '';
        // this.clientsList = this.clientsList.concat(this.selectedClients);
        // this.selectedClients =[];}
        }
    }

    // keyup() {
    //     if (this.searchText.trim() === '') {
    //         this.searchText = this.searchText.trim();
    //     }
    //     if (this.searchText === '') {
    //         this.filteredData = this.clientsList.filter((item: any) => item.name.toLocaleLowerCase().includes(this.searchText));
    //         this.filteredData = this.originalClientsList.filter((client: any) =>
    //             !this.selectedClients.includes(client)
    //         );
    //     }

    //     this.showTempForm = false;
    //     this.onReset();
    //     this.onResetentity();
    //     // Convert search text to lowercase for case-insensitive search
    //     const searchLower = this.searchText.toLowerCase();
    //     this.filteredData = this.clientsList.filter((item: any) => item.name.toLowerCase().includes(searchLower));

    //      console.log('searchText',this.searchText)
    //      console.log('data',this.data)
    //      console.log('filteredData',this.filteredData)

    //     // Update visibility based on the filtered data
    //     if (this.filteredData.length === 0) {
    //         this.showTempForm = true;
    //     }

    //     //this.isSelectAllVisible = this.filteredData.length > 0;
    //     this.isSelectAllVisible = this.clientsList.length > 0;

    //     const checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
    //     if (checkbox) {
    //         checkbox.checked = false;
    //     }
    // }
    
    //if form is incomplete
    
    isFormIncomplete(): boolean {
        return (
            this.tempClient.dirty ||
            this.tempClient.touched ||
            this.entityClient.dirty ||
            this.entityClient.touched
        );
    }

    getType(e: any, type: any) {
        // console.log('type',type)
        // console.log('e.target.name',e.target.name)
        // console.log('tempClient',this.tempClient.value)
        // console.log('entityClient',this.entityClient.value)

        // || this.tempClient.dirty ||  this.tempClient.touched || this.entityClient.dirty ||  this.entityClient.touched 

        // const tempVal = (this.tempClient.value.name.length > 1 || this.tempClient.value.lastName.length > 1 || this.tempClient.value.email.length > 1 || this.tempClient.value.country.length > 1);
        // const entityVal = (this.entityClient.value.fullname.length > 1 || this.entityClient.value.contact_person.length > 1 || this.entityClient.value.email.length > 1 || this.entityClient.value.country.length > 1);

        const tempVal = this.tempClient.dirty;
        const entityVal = this.entityClient.dirty;

        if (tempVal) {
            this.successModel = true;
            this.showAlert();
            return;
        }
        else if (entityVal) {
            this.successModel = true;
            this.showAlert();
            return;
        }
        else{
        this.selectedType = type;
        this.successModel = false;
        this.ClientType = e.target.name;
        this.CorpType
        this.tempClient.controls.type.patchValue(type);
        }
    }

    successResp(action: string) {
        if (action == 'yes') {
            this.successModel = false;
            if (this.selectedType == 'individual') {
                this.ClientType = 'entity';
            }
            else {
                this.ClientType = 'individual';
            }
        }
        this.onReset();
        this.onResetentity();
    }
    noResp(action: string) {
        if (action == 'no') {
            this.successModel = false;
            this.selectedType = this.selectedType;
        }
    }

    //For cancel button dialog
    keyResp(action: string) {
        if (action == 'yes') {
            this.keyModel = false;
            this.searchText = '';
            this.tempList = false;
            this.isSelectAllVisible = true;
            this.showTempForm = false;
            this.entityClient.reset();
            this.tempClient.reset();
            this.submitted = false;
            this.entitysubmitted = false;
            this.childButtonEvent.emit(this.clients);
            this.clientsList = this.originalClientsList.filter((client: any) =>
                    !this.selectedClients.includes(client)
            ); // get back the client list
        }
    }
    nokeyResp(action: string) {
        if (action == 'no') {
            this.keyModel = false
        }
    }

    toggleType() {
        this.selectedType = this.selectedType === 'individual' ? 'entity' : 'individual';
    }

    saveTempClientId(createdId: string) {
        let existing = localStorage.getItem('tempclients');
        let tempClients: string[] = existing ? JSON.parse(existing) : [];

        // Push new id if not already present
        if (!tempClients.includes(createdId)) {
            tempClients.push(createdId);
        }
        localStorage.setItem('tempclients', JSON.stringify(tempClients));

        // console.log('selectedClients',this.selectedClients)
        // console.log('Clients',this.clientsList)

        // Set isTemp flag
        if (tempClients.length > 0) {
            localStorage.setItem('isTemp', 'true');
        } else {
            localStorage.setItem('isTemp', 'false');
        }
    }

    oneEntitySubmit(submitType: string) {
        this.inputsubmit = submitType; 
        this.isSaveEnable = true;
        this.entitysubmitted = true;
        if (this.entityClient.invalid) {
            return;
        }
        // Check if email and confirmemail do not match
        if (this.entityClient.value.confirmemail !== this.entityClient.value.email) {
            return;
        }
        if (this.inputsubmit == 'entity') {
            let object = {
                "fullname": this.entityClient.value.fullname,
                "contact_person": this.entityClient.value.contact_person,
                "email": this.entityClient.value.email,
                "contact_phone": this.entityClient.value.phonenumber,
                "country": this.entityClient.value.country || 'India',
                //"group_acls": this.groups.map((obj: any) => obj.id)
            }

            this.httpService.sendPostRequest(URLUtils.relationshipInviteEntity, object).subscribe((res: any) => {
                 if (res.error==true) {
                    this.toastr.error(res.msg);
                    this.showTempForm = true;
                    this.submitted = false; 
                    return;
                }
               else {
                    let dObj = {
                        id: res?.profId,
                        name: res?.name,
                        type: 'entity'
                    }
                    this.selectedClients.push(dObj);
                    this.showTempForm = false;
                    this.toastr.success('Client Invitation Sent Successfully')
                    this.saveTempClientId(res.rel_id); //  temcliId to localStorage array
                    this.onResetentity();
                    this.OnFormCancel();
                    this.getClientsData();
                    this.selectedEntity.setValue(null); // clears input
                    // this.getTempData();
                    // this.sendReq(dObj); // send req
                    // this.confirmationDialogService.confirm('Success for Entity', `Congratulations! You have successfully created Entity  ${this.tempClient.value.name} to  ${this.data.Title}`, false, 'Add Team Members', 'Cancel', true)
                    //     .then((confirmed) => {
                    //         this.onResetentity();
                    //         this.OnFormCancel();
                    //     })
                }
            },
                (error: HttpErrorResponse) => {
                    if (error.status === 401 || error.status === 403 || error.status === 200) {
                        const errorMessage = error.error.msg || 'Unauthorized';
                        this.toastr.error(errorMessage);
                    } else if (error.status === 400) {
                        if (error.error.errors) {
                            error.error.errors.forEach((err: { field: string; msg: string }) => {
                                if(this.entityClient.value.email.length > 1 && (err.msg === "Account already exists with this email" || err.msg === "Account already exists with this Firm Name")){
                                    this.toastr.error(`${err.msg}`);
                                }
                            });
                        } else {
                            this.toastr.error('Bad Request');
                        }
                    } else {
                        this.toastr.error('An unexpected error occurred');
                    }
                }
            )

        }
        //this.onResetentity();
        // this.selectedEntity.setValue(null); // clears input
    }
    onindividualSubmit(submitType: string) {
        //console.log('submitType',submitType)
        //console.log('confirmemail',this.tempClient.value)
        this.inputsubmit = submitType; 
        this.isSaveEnable = true;
        this.submitted = true;
        if (this.tempClient.invalid) {
            return;
        }
        // Check if email and confirmemail do not match
        if (this.tempClient.value.confirmemail !== this.tempClient.value.email) {
            return;
        }

        if (this.inputsubmit == 'temp') {
            let obj = {
                "first_name": this.tempClient.value.name,
                "last_name": this.tempClient.value.lastName,
                "email": this.tempClient.value.email,
                "country": this.tempClient.value.country || 'India',
                "mobile": this.tempClient.value.phonenumber,
                //"group_acls": this.groups.map((obj: any) => obj.id)
            }
            // console.log('..obj',obj)
            this.httpService.sendPostRequest(URLUtils.relationshipInviteConsumer, obj).subscribe((res: any) => {
                if (res.error==true) {
                    this.toastr.error(res.msg);
                    this.showTempForm = true;
                    this.submitted = false; 
                    return;
                }
                else {
                    let dObj = {
                        id: res?.conId,
                        name: res?.name,
                        type: 'consumer'
                    }
                    this.selectedClients.push(dObj);

                    this.toastr.success('Client Invitation Sent Successfully')
                    this.showTempForm = false;
                    this.saveTempClientId(res.rel_id); //  temcliId to localStorage array
                    this.onReset();
                    this.OnFormCancel();
                    this.getClientsData();
                    this.selectedEntity.setValue(null); // clears input
                    // this.getTempData();
                    // this.sendReq(dObj); // send req
                    // this.confirmationDialogService.confirm('Success', 'Congratulations! You have successfully sent relationship request ', false, 'Add Team Members', 'Cancel', true)
                    //     .then((confirmed) => {
                    //         this.onReset();
                    //         this.OnFormCancel();
                    //     })
                }
                // else{
                //     this.confirmationDialogService.confirm('failed', 'sorry! You have sent duplicate  request ', false, 'Add Team Members', 'Cancel', true)
                // }
            },
                (error: HttpErrorResponse) => {
                    if (error.status === 401 || error.status === 403 || error.status === 200) {
                        const errorMessage = error.error.msg || 'Unauthorized';
                        this.toastr.error(errorMessage);
                    } else if (error.status === 400) {
                        if (error.error.errors) {
                            error.error.errors.forEach((err: { field: string; msg: string }) => {
                                if(this.tempClient.value.email.length > 1 && err.msg === "Account already exists with this email"){
                                this.toastr.error(`${err.msg}`);
                                }
                            });
                        } else {
                            this.toastr.error('Bad Request');
                        }
                    } else {
                        this.toastr.error('An unexpected error occurred');
                    }
                }
            );
        }
        //this.onReset();
        //this.selectedEntity.setValue(null); // clears input
    }

    // onSubmit() {
    //     this.submitted = true;
    //     console.log(this.tempClient);
    //     if (this.inputsubmit == 'invite') {
    //         if (this.tempClient.value.type === 'entity') {
    //             let obj = {
    //                 "entityName": this.tempClient.value.name,
    //                 "fullname": this.tempClient.value.name,
    //                 "contact_person": this.tempClient.value.name,
    //                 "email": this.tempClient.value.email,
    //                 "contactPhone": this.tempClient.value.phonenumber,
    //                 "country": "USA",
    //                 "groups": this.groups.map((obj: any) => obj.id)
    //             }
    //              this.httpService.sendPostRequest(URLUtils.inviteEntity, obj).subscribe((res: any) => {
    //                 if (!res.error) {
    //                      this.confirmationDialogService.confirm('Success', 'Congratulations! You have successfully sent relationship request ', false, 'Add Team Members', 'Cancel', true)
    //                          .then((confirmed) => {
    //                              this.OnFormCancel();
    //                         })
    //                  }
    //              })
    //         } else {
    //             let obj = {
    //                 "first_name": this.tempClient.value.name,
    //                 "last_name": this.tempClient.value.name,
    //                 "email": this.tempClient.value.email,
    //                 "country": "USA",
    //                 "groups": this.groups.map((obj: any) => obj.id)
    //             }
    //              this.httpService.sendPostRequest(URLUtils.inviteConsumer, obj).subscribe((res: any) => {
    //                  if (!res.error) {
    //                     this.confirmationDialogService.confirm('Success', `Congratulations! You have successfully created temp client  ${this.tempClient.value.name} to  ${this.data.Title}`, false, 'Add Team Members', 'Cancel', true)
    //                          .then((confirmed) => {
    //                             this.OnFormCancel();
    //                          })
    //                  }
    //              })
    //         }
    //     } else if (this.inputsubmit == 'temp') {

    //         let obj = {
    //             "name": this.tempClient.value.name,
    //             "lastName": this.tempClient.value.lastName,
    //             "email": this.tempClient.value.email,
    //             "phone": this.tempClient.value.phonenumber,
    //             "clientType": this.tempClient.value.type,
    //             "country": "USA"
    //         }
    //         this.httpService.sendPostRequest(URLUtils.tempClientPost, obj).subscribe((res: any) => {
    //             //console.log("error "+JSON.stringify(res)); 
    //             this.tempClients.push(res);
    //             localStorage.setItem('tempClients', JSON.stringify(this.tempClients));
    //             this.onReset();
    //  this.tempClient.reset();

    // if (!res.error) {
    //     this.confirmationDialogService.confirm('Success', `${res.msg}`, false, 'Add Team Members', 'Cancel', true)
    //         .then((confirmed) => {
    //             this.OnFormCancel();
    //         })
    // }
    //         }, error => {
    //             //console.log("error "+JSON.stringify(error)); 
    //             this.toastr.error(error.error.errors[0].msg)
    //         },)
    //     }
    // }
    onReset() {
        this.submitted = false;
        this.tempClient.controls['name'].setValue('');
        this.tempClient.controls['lastName'].setValue('');
        this.tempClient.controls['email'].setValue('');
        this.tempClient.controls['confirmemail'].setValue('');
        this.tempClient.controls['country'].setValue('');
        this.tempClient.controls['phonenumber'].setValue('');
    }
    onResetentity() {
        this.entitysubmitted = false;
        this.entityClient.controls['fullname'].setValue('');
        this.entityClient.controls['contact_person'].setValue('');
        this.entityClient.controls['email'].setValue('');
        this.entityClient.controls['confirmemail'].setValue('');
        this.entityClient.controls['country'].setValue('');
        this.entityClient.controls['phonenumber'].setValue('');
    }

    removeTempClient(val: any) {
        this.isSaveEnable = true;
        let index = this.tempClients.findIndex((d: any) => d.id === val.id); //find index in your array
        this.tempClients.splice(index, 1);
        localStorage.setItem('tempClients', JSON.stringify(this.tempClients));
    }


    getCorp() {
        this.corporateData = true;
        this.selectedOption = "";
    }

    getClient() {
        this.corporateData = false;
        this.tempList == true
    }
    restricttextSpace(event: any) {
        let inputValue: string = event.target.value;
        inputValue = inputValue.replace(/^\s+/, '');
        inputValue = inputValue.replace(/\s{2,}/g, ' ');
        event.target.value = inputValue;
    }

    truncateString(text: string): string {
        if (text.length > 25) {
            return text.slice(0, 25) + '...';
        }
        return text;
    }
    toggleView() {
        this.showAllItems = !this.showAllItems;
    }

    showAlert(){
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: '400px',
          data: { title: 'Alert', message: `Data will not be saved. Do you want to proceed ?` }
        });
        dialogRef.afterClosed().subscribe((result: any) => {
          //console.log('Dialog result:', result);
          if (result) {
            this.successResp('yes');
            this.toggleType();
          }
          else{
            this.noResp('no');
          }
        });
    }
    
}
